enquire.register("max-width: 851px", {
    match:function(){
        $("body").addClass("mobile").removeClass("desktop");
        checkDesktopNav();
    },
    unmatch:function(){
        // Desktop
        $("body").addClass("desktop").removeClass("mobile");
        checkDesktopNav();
    }
});